import { jsx as d } from "react/jsx-runtime";
import { a as t } from "../../index-BHXiaNZf.js";
import i from "classnames";
import { cld_core as m, cld as a } from "../../constants/cloudinary.js";
import { memo as c } from "react";
import '../../assets/Video.css';const l = "_video_2ssma_1", n = {
  video: l
}, p = c(({ publicId: o, className: r, thumbnailOffset: e, ...s }) => /* @__PURE__ */ d(
  t,
  {
    className: i(n.video, r),
    cldVid: a.video(o).quality("auto"),
    controls: !0,
    controlsList: "nodownload",
    poster: e ? m.video_url(o, { format: "png", offset: e }) : void 0,
    ...s
  }
));
p.displayName = "Video";
export {
  p as default
};
